import React from "react";
import { FloatingMenu } from "../../ui-library/FloatingMenu/FloatingMenu.tsx";
import { FloatingMenuItem } from "../../ui-library/FloatingMenu/FloatingMenuItem.tsx";

export const HistoryItemMenu: React.FC<{
  onClickDelete: () => void;
  onClickRename?: () => void;
}> = (props) => {
  return (
    <FloatingMenu>
      <FloatingMenuItem onClick={props.onClickRename}>
        Rename workflow
      </FloatingMenuItem>
      <FloatingMenuItem onClick={props.onClickDelete}>
        Delete workflow
      </FloatingMenuItem>
    </FloatingMenu>
  );
};
